import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ConfirmDirective} from "../../../../../directives/confirm/confirm.directive";
import {IsGrantedDirective} from "../../../../../directives/is-granted/is-granted.directive";

import {PaginatorComponent} from "../../../../layout/paginator/paginator.component";
import {RouterLink} from '@angular/router';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {BotRule} from '../../../../../models/bot-rule';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {BotRuleService} from '../../../../../services/bot-rule/bot-rule.service';

@Component({
  selector: 'app-bot-rule-list',
  imports: [
    ConfirmDirective,
    IsGrantedDirective,
    PaginatorComponent,
    RouterLink
],
  templateUrl: './bot-rule-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bot-rule-list.component.scss'
})
@IsGranted(['BOT_RULE_VIEW'])
@MetaTitle('Bot rules')
export class BotRuleListComponent implements OnInit {
  botRules: BotRule[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('position', 'asc');

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private botRuleService: BotRuleService
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.botRuleService.findAll({}, this.paginator, this.tableSorter).subscribe((botRules) => {
      this.botRules = botRules;

      this.loader.stopLoading();
    })
  }

  delete(botRule: BotRule): void {
    if (botRule.id) {
      this.loader.startLoading();
      this.botRuleService.delete(botRule.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Bot rule has been deleted');
        this.refresh();
      });
    }
  }

  up(botRule: BotRule): void {
    this.botRuleService.up(botRule).subscribe(() => {
      this.refresh();
    });
  }

  down(botRule: BotRule): void {
    this.botRuleService.down(botRule).subscribe(() => {
      this.refresh();
    });
  }
}
